import Config from 'react-native-config';
import type { EnrollmentCaptureSource } from '../types/faceRegistration';

const DEFAULT_ADD_SAMPLE_PATH = '/employees/{employeeId}/azure-person/faces';
const CAPTURE_SOURCES: readonly EnrollmentCaptureSource[] = [
  'HR_PORTAL',
  'ADMIN_PORTAL',
  'API',
];

function positiveInteger(name: string, value: string | undefined, fallback: number) {
  if (value === undefined || value === null || value === '') return fallback;
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed <= 0) {
    throw new Error(`${name} must be a positive integer`);
  }
  return parsed;
}

function resolveCaptureSource(value: string | undefined): EnrollmentCaptureSource {
  const trimmed = value?.trim();
  if (!trimmed) return 'HR_PORTAL';
  if ((CAPTURE_SOURCES as readonly string[]).includes(trimmed)) {
    return trimmed as EnrollmentCaptureSource;
  }
  throw new Error(
    `FACE_ENROLLMENT_CAPTURE_SOURCE must be one of: ${CAPTURE_SOURCES.join(', ')}`,
  );
}

function resolveAddSamplePath(employeeId: number) {
  const template =
    Config.FACE_ENROLLMENT_ADD_SAMPLE_PATH?.trim() || DEFAULT_ADD_SAMPLE_PATH;
  if (!template.includes('{employeeId}')) {
    throw new Error(
      'FACE_ENROLLMENT_ADD_SAMPLE_PATH must include the {employeeId} placeholder',
    );
  }
  return template.split('{employeeId}').join(String(employeeId));
}

export function getFaceEnrollmentConfig() {
  const pollIntervalMs = Math.max(
    1000,
    positiveInteger(
      'FACE_ENROLLMENT_TRAINING_POLL_INTERVAL_MS',
      Config.FACE_ENROLLMENT_TRAINING_POLL_INTERVAL_MS,
      1000,
    ),
  );
  const resultTimeoutMs = positiveInteger(
    'FACE_ENROLLMENT_TRAINING_TIMEOUT_MS',
    Config.FACE_ENROLLMENT_TRAINING_TIMEOUT_MS,
    60000,
  );
  if (resultTimeoutMs <= pollIntervalMs) {
    throw new Error('FACE_ENROLLMENT_TRAINING_TIMEOUT_MS must exceed the poll interval');
  }

  return {
    pollIntervalMs,
    resultTimeoutMs,
    recommendedSampleCount: 3,
    captureSource: resolveCaptureSource(Config.FACE_ENROLLMENT_CAPTURE_SOURCE),
    addSamplePath: resolveAddSamplePath,
    addSamplePathTemplate:
      Config.FACE_ENROLLMENT_ADD_SAMPLE_PATH?.trim() || DEFAULT_ADD_SAMPLE_PATH,
  };
}
